import { withIcon } from "../Icon"

export const IconCrown = withIcon(
  '<path fill="currentColor" d="M4.048 5.802 7.853 9.15l3.39-4.174a1 1 0 0 1 1.565.017l3.235 4.156 3.928-3.396a1 1 0 0 1 1.643.9L20.114 17H3.92L2.398 6.7a1 1 0 0 1 1.65-.898ZM3.998 18h16v1a1 1 0 0 1-1 1h-14a1 1 0 0 1-1-1v-1Z"/>',
)
